<div @show class="body main-component" [formGroup]="formGroup">

    <div class="left-column">

        <div class="notification-list">
            <div class="transaction-preview" [class.active]="!currentTransaction" (click)="createNew()">

                Neu anlegen
    
            </div>
    
            <ng-container *ngFor="let transaction of (issueTransactionManagementComponentService.issueTransactions$|async)">
    
                <div class="transaction-preview" (click)="setIssueTransaction(transaction)" [class.active]="currentTransaction === transaction">
    
                    <span class="text">{{transaction.name}}</span>
                    <mat-icon class="icon" color="warn" (click)="deleteTransaction($event, transaction)">delete_forever</mat-icon>
    
                </div>
    
            </ng-container>
        </div>

    </div>

    <div class="content" [formGroup]="formGroup">

        <app-issue-transaction-form></app-issue-transaction-form>

        <div class="footer">

            <button mat-raised-button color="primary" (click)="saveFormStatus()" [disabled]="formGroup.pristine">

                Speichern
    
            </button>

        </div>

    </div>

</div>